import { render, staticRenderFns } from "./VotingConfirmationDialog.vue?vue&type=template&id=529e6736&scoped=true&"
import script from "./VotingConfirmationDialog.vue?vue&type=script&lang=js&"
export * from "./VotingConfirmationDialog.vue?vue&type=script&lang=js&"
import style0 from "./VotingConfirmationDialog.vue?vue&type=style&index=0&id=529e6736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529e6736",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBanner,VCard,VCardActions,VCardText,VCol,VDivider,VRow,VSpacer,VTextField,VToolbar,VTooltip})
